var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"eventsPageRoot"},[_c('p',{staticClass:"text-h2 text-center font-weight-bold"},[_vm._v("All Events")]),_c('Events',{attrs:{"events":_vm.events}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }